import React from "react";
import { useRouteMatch } from "react-router-dom";
import { data } from "../../Assets/js/data";
import Oppo from "./Commission/Oppo";
import Sony from "./Commission/Sony";
import TourismBoards from "./Commission/TourismBoards";
import UniversalJapan from "./Commission/UniversalJapan";
import WandererBracelets from "./Commission/WandererBracelets";
import Stromtech from "./Commission/Stromtech";
import OretStudio from "./Commission/OretStudio";

export const CommissionContent = name => {
  const pageName = name.name;
  switch (pageName) {
    case "oppo-indonesia":
      return <Oppo />;
    case "sony-alpha-indonesia":
      return <Sony />;
    case "tourism-boards":
      return <TourismBoards />;
    case "universal-studio-japan":
      return <UniversalJapan />;
    case "stromtech":
      return <Stromtech />;
    case "wanderer-bracelets":
      return <WandererBracelets />;
    case "oret-studio":
      return <OretStudio />;
    default:
      return <h1>NOT FOUND</h1>;
  }
};

export const Commission = () => {
  const match = useRouteMatch("/commissions/:name");
  const pageData = data.commissions.find(
    commision => commision.link === match.params.name
  );
  return (
    <div className="commission-container">
      <div
        className="commission-header"
        style={{
          backgroundImage: `url(${pageData.thumb})`
        }}
      >
        <h1>{pageData.title}</h1>
      </div>
      <CommissionContent name={match.params.name} />
    </div>
  );
};
export default Commission;
